import React from 'react';
import { useRecoilValue } from 'recoil';
import { freeShippingThresholdInDollars, getTotalForShippingDiscountFromCart } from '../../discounts';
import { ShopifyCart } from '../../models/ShopifyCart.model';
import { shopifyState, toViewPriceFnState } from '../../recoil/atoms';
import styles from './CartShippingProgress.module.scss';

interface Props {
  cart?: ShopifyCart;
}

export const CartShippingProgress: React.FC<Props> = ({ cart }) => {
  const shopify = useRecoilValue(shopifyState);
  const toViewPriceFn = useRecoilValue(toViewPriceFnState);
  const isUSD = shopify?.currency.active === 'USD';

  const total = cart ? getTotalForShippingDiscountFromCart(cart) : 0;

  const difference = freeShippingThresholdInDollars - total;
  const showMessage = isUSD && !!cart?.lineItems?.length;
  const completion = (100 * total) / freeShippingThresholdInDollars;

  return showMessage ? (
    <div className={styles.freeShippingProgress}>
      {difference > 0 ? (
        <span>
          You are <span className={styles.amount}>{toViewPriceFn(difference, 0)}</span> away from free shipping
        </span>
      ) : (
        <span>You get free standard shipping!</span>
      )}
      <div
        className={styles.progress}
        style={{ background: `linear-gradient(to right, #6261E8 ${completion.toFixed()}%, #e6e6e6 ${(100 - completion).toFixed()}%)` }}
      />
    </div>
  ) : (
    <React.Fragment />
  );
};

export default CartShippingProgress;
